export default [
    {
        path: '/audit/process',
        name: 'auditProcess',
        component: () => import('@/views/audit/process.vue')
    },
];